import React from "react";

const LoadingPlaceholder = () => {
  return (
    <div className="max-w-7xl mx-auto px-0 py-5">
      {/* Steel gradient title placeholder */}
      <div
        className="mx-auto mb-6 w-72 h-12 rounded
          bg-gradient-to-r
          from-gray-500
          via-gray-300
          via-gray-100
          to-gray-600
          animate-pulse"
      ></div>

      {/* Divider line with steel gray */}
      <div className="w-24 mx-auto mb-10 border-b-2 border-gray-400 opacity-50 animate-pulse"></div>

      <div className="relative flex items-center">
        {/* Left button placeholder */}
        <div
          className="absolute left-0 z-20 rounded-full p-2 shadow-md animate-pulse"
          style={{
            top: "50%",
            transform: "translateY(-50%)",
            width: 40,
            height: 40,
            background:
              "linear-gradient(135deg, #a0a0a0 25%, #c0c0c0 50%, #909090 75%)",
          }}
          aria-label="Loading left button"
        ></div>

        {/* Scroll container placeholder */}
        <div
          className="flex space-x-8 overflow-x-auto overflow-y-hidden scrollbar-hide px-12 md:px-0"
          style={{ scrollSnapType: "x mandatory", height: "26.5rem" }}
        >
          {[...Array(5)].map((_, idx) => (
            <div
              key={idx}
              className="snap-center flex-shrink-0 w-72 h-[25rem] rounded-xl animate-pulse"
              style={{
                background:
                  "linear-gradient(135deg, #808080 25%, #a9a9a9 50%, #696969 75%)",
              }}
            />
          ))}
        </div>

        {/* Right button placeholder */}
        <div
          className="absolute right-0 z-20 rounded-full p-2 shadow-md animate-pulse"
          style={{
            top: "50%",
            transform: "translateY(-50%)",
            width: 40,
            height: 40,
            background:
              "linear-gradient(135deg, #a0a0a0 25%, #c0c0c0 50%, #909090 75%)",
          }}
          aria-label="Loading right button"
        ></div>
      </div>
    </div>
  );
};

export default LoadingPlaceholder;
